/**
 * Food Manufacturing icon — Factory + Food (option 1).
 * Custom 24×20 stroke-based icon for the Manufacturing sidebar section.
 */
const factoryIconTokens = {
  iconFactoryData:
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='20' viewBox='0 0 24 20' fill='none' stroke='currentColor' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M2.5 17.5h19'/%3E%3Cpath d='M4 17.5V9.5l4 2.3V9.5l4 2.3V6.5h7.5v11'/%3E%3Cpath d='M14 6.5V3.5h3.5v3'/%3E%3Cpath d='M6.5 14.5h1.5'/%3E%3Cpath d='M11 14.5h1.5'/%3E%3Cpath d='M15.5 14.5h1.5'/%3E%3Cpath d='M4.5 7.2c1.6-1.4 3.3-1.4 4.9 0'/%3E%3C/svg%3E",
  iconFactoryWidth: 24,
  iconFactoryHeight: 20,
}

export default factoryIconTokens
